import React, { useEffect } from 'react';

export function CustomParticipantCreate({ onPlayerID, connecting }) {
  // Get participant key from URL
  const urlParams = new URLSearchParams(window.location.search);
  const participantKeyFromUrl = urlParams.get("participantKey") || "";

  // Immediately create player and skip any ID input UI
  useEffect(() => {
    if (participantKeyFromUrl && participantKeyFromUrl.trim() !== "") {
      onPlayerID(participantKeyFromUrl.trim());
    }
  }, [participantKeyFromUrl, onPlayerID]);

  // Minimal loading state while creating the player
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4 text-center">
        <span className="inline-flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full mb-3">
          <svg className="w-6 h-6 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
        <div className="text-gray-800 font-medium">Connecting to the experiment…</div>
        {connecting && (
          <div className="text-sm text-gray-500 mt-2">Please wait a moment.</div>
        )}
      </div>
    </div>
  );
}
